<ion-radio-group (ionChange)="setData($event)" [value]="selected()">
  <div class="or-d-flex or-flex-col">
    @for (item of reasons; track item.value) {
      <ion-radio
        [value]="item.value"
        labelPlacement="end"
        alignment="center"
        justify="start"
        class="or-p-16-px or-mb-8-px or-w-100-pc"
        [ngClass]="isSelected(item.value) ? 'is-active or-bg-focus or-color-main-1' : 'is-no-active or-bg-white'">
        <div [ngClass]="isSelected(item.value) ? 'or-head-xs or-color-main-1' : 'or-text-sm or-color-black'">
          {{ item.name }}
        </div>
      </ion-radio>
    }
  </div>
</ion-radio-group>
